<div class="page-header">
  <div>
    <h1>{{ t('MonitoringTitle') }}</h1>
    <p>{{ t('HubMonitoringIntro') }}</p>
  </div>
</div>

@if (error) {
  <p class="message error">{{ error }}</p>
}

<form class="card filter-card" (ngSubmit)="applyFilters()">
  <label>{{ t('HubLogType') }}
    <select name="type" [(ngModel)]="type" (change)="applyFilters()">
      @for (option of logTypes; track option) {
        <option [value]="option">{{ option === '' ? t('HubAllLogTypes') : option }}</option>
      }
    </select>
  </label>
  <label>{{ t('HubLogSearch') }}
    <input name="query" [(ngModel)]="pendingQuery" [placeholder]="t('HubLogSearchPlaceholder')">
  </label>
  <div class="button-row">
    <button class="primary-button" type="submit">{{ t('HubApplyFilters') }}</button>
    <button class="secondary-button" type="button" (click)="clearFilters()">{{ t('HubClearFilters') }}</button>
  </div>
</form>

@if (loading) {
  <p>{{ t('HubLogsLoading') }}</p>
}

@if (!loading) {
  <div class="card logs-card">
    <div class="table-summary">
      <span>{{ t('HubLogResults') }} {{ firstLogIndex() }}-{{ lastLogIndex() }} {{ t('HubOf') }} {{ total }}</span>
      <span>{{ t('HubPage') }} {{ page }} {{ t('HubOf') }} {{ totalPages }}</span>
    </div>
    <table class="table">
      <thead><tr><th class="log-date-cell">{{ t('HubLogDate') }}</th><th>{{ t('HubLogType') }}</th><th>{{ t('HubLogMessage') }}</th></tr></thead>
      <tbody>
        @for (log of logs; track log) {
          <tr>
            <td class="log-date-cell" [attr.data-label]="t('HubLogDate')"><time [attr.datetime]="logIsoDate(log.date)">{{ logDate(log.date) | date:'d MMM y, HH:mm:ss' }}</time></td>
            <td [attr.data-label]="t('HubLogType')"><span class="log-type" [class]="log.type">{{ log.type }}</span></td>
            <td [attr.data-label]="t('HubLogMessage')"><pre>{{ log.message }}</pre></td>
          </tr>
        }
        @if (logs.length === 0) {
          <tr><td colspan="3">{{ t('HubNoLogs') }}</td></tr>
        }
      </tbody>
    </table>
    @if (totalPages > 1) {
      <div class="pagination-row">
        <button class="secondary-button" type="button" [disabled]="page <= 1" (click)="setPage(page - 1)">{{ t('HubPreviousPage') }}</button>
        <button class="secondary-button" type="button" [disabled]="page >= totalPages" (click)="setPage(page + 1)">{{ t('HubNextPage') }}</button>
      </div>
    }
  </div>
}
